import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isDarkTheme: true,
};

export const changeThemeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    changeTheme: (state) => {
      state.isDarkTheme = !state.isDarkTheme;
    },
  },
});

// Action creators are generated for each case reducer function
export const { changeTheme } = changeThemeSlice.actions;

export default changeThemeSlice.reducer;
